import { render, staticRenderFns } from "./LoginHistoryManage.vue?vue&type=template&id=5f7245ba&"
import script from "./LoginHistoryManage.vue?vue&type=script&lang=js&"
export * from "./LoginHistoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports